import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const razorpay = defineConnector({
  identifier: "razorpay",
  name: "Razorpay",
  tagLine: "Payment gateway",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.razorpay\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your Razorpay API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Razorpay Dashboard](https://dashboard.razorpay.com/app/keys) and go to **Settings → API Keys** to generate a new key pair. Use the Key ID as the username and the Key Secret as the password.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Razorpay account settings.",
        },
        {
          kind: "input",
          label: "Key ID",
          required: true,
          target: { kind: "secrets", field: "username" },
          placeholder: "rzp_test_*************",
          helperText: "Your Key ID",
        },
        {
          kind: "input",
          label: "Key Secret",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText: "Your Key Secret",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.razorpay.com/v1/orders",
  },
});
